import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
const app = createApp(App);

/** ios方法 **/
window.setUserInfo = function (data){
    console.log('你好啊！')
    console.log(data)
    localStorage.setItem('userInfo', data)
}
import {iosFun} from "@/assets/js/iosFun";
app.config.globalProperties.$iosFun = iosFun;
iosFun.getUserInfo('','window.setUserInfo')


/** Vconsole */
import Vconsole from 'vconsole'
if (process.env.VUE_APP_CURRENTMODE !== 'PROD') {
    app.use(new Vconsole());
}


/** Vant */
import Vant from 'vant';
import 'vant/lib/index.css';
app.use(Vant);


/** api */
import {api} from '@/api/api';
app.config.globalProperties.$api = api;


app.use(store).use(router).mount('#app')
